import { MicrowaveIcon } from './MicrowaveIcon';

/**
 * author: GreenTurtwig
 * id 62F69C7A-4CBA-444A-8BFE-E5B7A891CF5D
 * name microwave
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microwave.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const MicrowaveOvenIcon = MicrowaveIcon;
export default MicrowaveOvenIcon